import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { baseApi } from "./baseApi";
import movesReducer from "./moves/slice";
import sessionReducer from "./session/slice";
import moversReducer from "./mover/slice";
import chargesApi from "./charges/apis";
import customerPaymentsApi from "./customer_payments/apis";

const rootReducer = combineReducers({
  moves: movesReducer,
  session: sessionReducer,
  movers: moversReducer,
  chargesApi: chargesApi.reducer,
  customerPaymentsApi: customerPaymentsApi.reducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

// const rtkQueryErrorLogger = (store) => (next) => (action) => {
//   if (action.payload?.status === 401) {
//     store.dispatch(logOut());
//   }

//   return next(action);
// };

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: {
        warnAfter: 50,
      },
    }).concat(baseApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
